export default {"src":"/_next/static/media/special-requests.d17b4292.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};